/* Build Your Skin Routine — guided skin assessment → personalized, explained routine.
   Sukoshi-inspired editorial redesign: flat hairlines, display-serif headings.
   Result steps support BOTH the auto switcher ("Try another") and a manual
   per-step product search (predictive search → /products/{handle}.js). */
(function () {
  var root = document.querySelector('[data-assessment]');
  if (!root) return;
  var cartRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var stage = root.querySelector('[data-as-stage]');
  var progEl = root.querySelector('[data-as-prog]');

  function I(p) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' + p + '</svg>'; }
  var ICONS = {
    droplet: I('<path d="M12 3.4c-.3 0-5.5 5.9-5.5 10.3a5.5 5.5 0 0 0 11 0C17.5 9.3 12.3 3.4 12 3.4Z"/><path d="M9.7 13.8a2.4 2.4 0 0 0 2 2.3"/>'),
    combo: I('<circle cx="12" cy="12" r="8.5"/><path d="M12 3.5v17"/><path d="M8.5 9.8c-.15.1-1 1-1 1.8a1 1 0 0 0 2 0c0-.8-.85-1.7-1-1.8Z"/><path d="M15.5 11.2 16.5 12.5 15.5 13.8 14.5 12.5Z"/>'),
    oily: I('<circle cx="12" cy="12" r="8.5"/><path d="M7.6 9.4a6 6 0 0 1 6.6-1.2"/>'),
    shield: I('<path d="M12 3.2 19 6v5.5c0 4.2-2.9 7.4-7 8.5-4.1-1.1-7-4.3-7-8.5V6l7-2.8Z"/><path d="m9.2 11.8 1.9 1.9 3.7-3.7"/>'),
    target: I('<rect x="4" y="4" width="16" height="16" rx="5"/><circle cx="14.5" cy="10" r="1.6"/><circle cx="9" cy="14.8" r="1"/>'),
    sparkle: I('<path d="M12 3.5 13.4 9.6 19.5 11 13.4 12.4 12 18.5 10.6 12.4 4.5 11 10.6 9.6Z"/><path d="M19 3.4 19.5 4.9 21 5.4 19.5 5.9 19 7.4 18.5 5.9 17 5.4 18.5 4.9Z"/>'),
    waves: I('<path d="M4 8c2.7-2.2 5.3-2.2 8 0s5.3 2.2 8 0"/><path d="M4 13c2.7-2.2 5.3-2.2 8 0s5.3 2.2 8 0"/><path d="M4 18c2.7-2.2 5.3-2.2 8 0s5.3 2.2 8 0"/>'),
    leaf: I('<path d="M5 19C5 11 11 5 19 5c0 8-6 14-14 14Z"/><path d="M5 19c2.5-3.5 5.5-6.5 9-9"/>'),
    pores: I('<circle cx="8" cy="8" r="1.2"/><circle cx="13.5" cy="7" r="1.2"/><circle cx="17" cy="11.5" r="1.2"/><circle cx="11" cy="12" r="1.2"/><circle cx="7.5" cy="14.5" r="1.2"/><circle cx="14.5" cy="16" r="1.2"/>'),
    balance: I('<circle cx="12" cy="12" r="8.5"/><path d="M3.5 12h17"/>'),
    air: I('<path d="M3 8.5h10.5a2.5 2.5 0 1 0-2.4-3.3"/><path d="M3 12.5h15a2.5 2.5 0 1 1-2.4 3.3"/><path d="M3 16.5h8"/>'),
    layers2: I('<path d="M4 9h16M4 15h16"/>'),
    layers3: I('<path d="M4 7h16M4 12h16M4 17h16"/>'),
    layers4: I('<path d="M4 6h16M4 10h16M4 14h16M4 18h16"/>'),
    arrow: I('<path d="M4 12h15M13 6l6 6-6 6"/>'),
    swap: I('<path d="M4 9h13l-3.5-3.5M20 15H7l3.5 3.5"/>'),
    cart: I('<path d="M4 5h1.5l1.7 10.5A1.5 1.5 0 0 0 8.7 17h7.6a1.5 1.5 0 0 0 1.5-1.2L19 8H6.2"/><circle cx="9" cy="20" r="1.1"/><circle cx="16" cy="20" r="1.1"/>'),
    search: I('<circle cx="11" cy="11" r="6.5"/><path d="m20 20-4.4-4.4"/>'),
    pump: I('<rect x="7.5" y="8.5" width="9" height="12.5" rx="2.5"/><path d="M10 8.5V6h4v2.5"/><path d="M12 6V3.5h2.5"/>'),
    tube: I('<rect x="9.3" y="3.5" width="5.4" height="3" rx="1"/><path d="M8.5 6.5h7v11a2.5 2.5 0 0 1-2.5 2.5h-2a2.5 2.5 0 0 1-2.5-2.5z"/><path d="M9 17h6"/>'),
    bottle: I('<path d="M10 3.5h4v2.3c0 .5.15.9.45 1.3l.5.6c.35.45.55 1 .55 1.6V19a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2V9.9c0-.6.2-1.15.55-1.6l.5-.6c.3-.4.45-.8.45-1.3V3.5Z"/>'),
    flask: I('<path d="M10.5 3.5h3v2.4l1.9 2.4a4 4 0 0 1 .85 2.5V18a3 3 0 0 1-3 3h-2.5a3 3 0 0 1-3-3v-4.8a4 4 0 0 1 .85-2.5l1.9-2.4V3.5Z"/><path d="M10.5 3.5h3"/>'),
    dropper: I('<rect x="10.25" y="2.75" width="3.5" height="3.25" rx="1.2"/><path d="M12 6v4M10 10h4"/><path d="M9 10.5h6v8.5a2.25 2.25 0 0 1-2.25 2.25h-1.5A2.25 2.25 0 0 1 9 19z"/>'),
    jar: I('<path d="M8 10V8.2a1.2 1.2 0 0 1 1.2-1.2h5.6A1.2 1.2 0 0 1 16 8.2V10"/><rect x="6.5" y="10" width="11" height="9.5" rx="2"/><path d="M6.5 13h11"/>'),
    sun: I('<circle cx="12" cy="12" r="3.8"/><path d="M12 3.3v2.1M12 18.6v2.1M3.3 12h2.1M18.6 12h2.1M5.9 5.9l1.5 1.5M16.6 16.6l1.5 1.5M18.1 5.9l-1.5 1.5M7.4 16.6l-1.5 1.5"/>'),
    eye: I('<path d="M2.6 12S6 6.6 12 6.6 21.4 12 21.4 12 18 17.4 12 17.4 2.6 12 2.6 12Z"/><circle cx="12" cy="12" r="2.6"/>')
  };
  function svg(k) { return ICONS[k] || ''; }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); }
  function money(cents) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'CAD';
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur, currencyDisplay: 'narrowSymbol' }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function searchPlaceholder() {
    // Long copy clips on narrow phones — keep it short there, rich on desktop.
    var small = window.matchMedia && window.matchMedia('(max-width: 680px)').matches;
    return small ? 'Search any product…' : 'Prefer something else? Search any product…';
  }

  var QUESTIONS = [
    { key: 'skintype', phase: 0, q: "How does your skin usually feel?", hint: "Most days, without product on.", cls: 'two', opts: [
      { t: "Dry", s: "Tight or flaky", v: "hydration", i: "droplet" },
      { t: "Combination", s: "Oily T-zone, dry cheeks", v: "pores", i: "combo" },
      { t: "Oily", s: "Shiny, visible pores", v: "pores", i: "oily" },
      { t: "Sensitive", s: "Reacts and reddens easily", v: "sensitive", i: "shield" } ] },
    { key: 'goal', phase: 1, q: "What's your main goal?", hint: "The one thing you'd change first.", cls: 'three', opts: [
      { t: "Hydration", s: "Plump, dewy skin", v: "hydration", i: "droplet" },
      { t: "Clear breakouts", s: "Calm acne & clogged pores", v: "acne", i: "target" },
      { t: "Brighten", s: "Fade dark spots & dullness", v: "brightening", i: "sparkle" },
      { t: "Smooth fine lines", s: "Firm & bounce", v: "aging", i: "waves" },
      { t: "Calm redness", s: "Soothe sensitivity", v: "sensitive", i: "leaf" },
      { t: "Refine pores", s: "Balance oil & texture", v: "pores", i: "pores" } ] },
    { key: 'finish', phase: 2, q: "How do you like your skin to feel?", hint: "Your ideal finish.", cls: 'three', opts: [
      { t: "Dewy", s: "Glass-skin glow", v: "dewy", i: "droplet" },
      { t: "Natural", s: "Soft & balanced", v: "natural", i: "balance" },
      { t: "Fresh", s: "Light, never greasy", v: "fresh", i: "air" } ] },
    { key: 'time', phase: 2, q: "How much time do you have?", hint: "We'll size your routine to fit.", cls: 'three', opts: [
      { t: "Keep it simple", s: "4 essential steps", v: "4", i: "layers2" },
      { t: "A proper routine", s: "6 steps", v: "6", i: "layers3" },
      { t: "The full ritual", s: "8 steps", v: "8", i: "layers4" } ] }
  ];
  var MATCH = {
    hydration: ['hydrat', 'dry', 'dull', 'dehydr'], acne: ['acne', 'blemish', 'breakout', 'pore'],
    brightening: ['bright', 'dark', 'tone', 'pigment', 'spot', 'dull'], aging: ['age', 'wrinkle', 'fine line', 'firm', 'elastic', 'lift'],
    sensitive: ['sensit', 'red', 'calm', 'sooth', 'barrier', 'cica'], pores: ['pore', 'oil', 'sebum', 'texture', 'shine']
  };
  var TIER = { essentials: 1, complete: 2, full: 3 }, LEVEL = { '4': 1, '6': 2, '8': 3 };

  var pools = Array.prototype.map.call(root.querySelectorAll('[data-pool]'), function (el) {
    return { key: el.getAttribute('data-key'), name: el.getAttribute('data-name'), when: el.getAttribute('data-when'),
      tier: el.getAttribute('data-tier'), icon: el.getAttribute('data-icon'), why: el.getAttribute('data-why') || '',
      products: Array.prototype.map.call(el.querySelectorAll('[data-product]'), function (p) {
        return { vid: p.getAttribute('data-vid'), price: parseInt(p.getAttribute('data-price'), 10) || 0, title: p.getAttribute('data-title'),
          brand: p.getAttribute('data-brand'), handle: p.getAttribute('data-handle'), image: p.getAttribute('data-image'), concerns: p.getAttribute('data-concerns') || '' };
      }) };
  });
  function candidates(pool, concern) {
    var kw = MATCH[concern] || [];
    var m = pool.products.filter(function (p) { return kw.some(function (k) { return p.concerns.indexOf(k) !== -1; }); });
    return { list: m.length ? m : pool.products, matched: m.length > 0 };
  }

  var idx = 0, name = '', ans = {}, swaps = {}, manual = {};
  var SCREENS = [{ type: 'intro', phase: 0 }].concat(QUESTIONS.map(function (q) { return { type: 'q', q: q, phase: q.phase }; })).concat([{ type: 'result', phase: 3 }]);

  function setProg(phase, on) {
    progEl.className = 'sora-as__prog p' + phase;
    progEl.hidden = !on;
    root.querySelectorAll('.sora-as__seg').forEach(function (seg) {
      var p = parseInt(seg.getAttribute('data-phase'), 10);
      seg.classList.toggle('is-done', p < phase);
      seg.classList.toggle('is-active', p === phase);
    });
  }

  function fade(html) { stage.innerHTML = html; stage.classList.remove('is-in'); void stage.offsetWidth; stage.classList.add('is-in'); window.scrollTo({ top: root.getBoundingClientRect().top + window.pageYOffset - 12, behavior: 'smooth' }); }

  function render() {
    var sc = SCREENS[idx];
    setProg(sc.phase, true);
    if (sc.type === 'intro') return renderIntro();
    if (sc.type === 'q') return renderQ(sc.q);
    if (sc.type === 'result') return renderResult();
  }

  function renderIntro() {
    fade('<div class="sora-as__center">' +
      '<p class="sora-as__kicker">Skin assessment</p>' +
      '<h1 class="sora-as__h1">Let\'s find your perfect routine</h1>' +
      '<p class="sora-as__lede">A few quick questions, and we\'ll build a Korean skincare routine just for you — with a plain-English reason for every step.</p>' +
      '<input class="sora-as__input" data-as-name type="text" placeholder="What should we call you? (optional)" value="' + esc(name) + '" autocomplete="given-name">' +
      '<button type="button" class="sora-btn sora-as__begin" data-as-next>Begin</button>' +
      '<p class="sora-as__meta">Takes about 30 seconds &nbsp;·&nbsp; Free samples with every order</p>' +
      '</div>');
  }

  function renderQ(q) {
    var chosen = ans[q.key], qn = 0;
    QUESTIONS.forEach(function (x, i) { if (x.key === q.key) qn = i + 1; });
    var opts = q.opts.map(function (op) {
      return '<button type="button" class="sora-as__opt' + (chosen === op.v ? ' is-sel' : '') + '" data-as-opt="' + op.v + '">' +
        '<span class="sora-as__optic">' + svg(op.i) + '</span>' +
        '<span class="sora-as__optt">' + op.t + '</span><span class="sora-as__optsub">' + op.s + '</span></button>';
    }).join('');
    var greet = name ? ('<p class="sora-as__hi">' + esc(name) + ',</p>') : '';
    fade('<div class="sora-as__center">' +
      '<p class="sora-as__kicker">Question ' + qn + ' of ' + QUESTIONS.length + '</p>' + greet +
      '<h2 class="sora-as__h2">' + q.q + '</h2>' +
      '<p class="sora-as__qhint">' + q.hint + '</p>' +
      '<div class="sora-as__opts sora-as__opts--' + q.cls + '">' + opts + '</div>' +
      '<button type="button" class="sora-as__back" data-as-back>&larr; Back</button>' +
      '</div>');
  }

  function prodInner(pool, item) {
    return '<button type="button" class="sora-as__thumb" data-as-qv data-handle="' + esc(item.handle) + '" data-brand="' + esc(item.brand) + '" data-title="' + esc(item.title) + '" data-price="' + item.price + '" data-image="' + esc(item.image || '') + '" aria-label="Quick view ' + esc(item.title) + '">' + (item.image ? '<img src="' + esc(item.image) + '" alt="" loading="lazy">' : '') + '</button>' +
      '<div class="sora-as__prodb"><span class="sora-as__prodbrand">' + esc(item.brand) + '</span>' +
      '<span class="sora-as__prodname">' + esc(item.title) + '</span>' +
      '<span class="sora-as__prodprice">' + money(item.price) + '</span></div>' +
      '<button type="button" class="sora-as__swap" data-as-swap="' + esc(pool.key) + '">' + svg('swap') + '<span>Try another</span></button>';
  }
  function slotHTML(pool, item, matched, n) {
    var whenLabel = pool.when === 'am' ? 'Morning' : pool.when === 'pm' ? 'Evening' : 'Morning &amp; evening';
    var reason = matched ? ('Matched to your <strong>' + (goalLabel() || 'skin') + '</strong> goal.') : 'A well-loved all-rounder for this step.';
    return '<div class="sora-as__step" data-step="' + esc(pool.key) + '">' +
      '<span class="sora-as__stepn">' + pad(n) + '</span>' +
      '<div class="sora-as__stepbody">' +
        '<div class="sora-as__stephead"><span class="sora-as__stepic">' + svg(pool.icon) + '</span>' +
          '<h3 class="sora-as__stepname">' + pool.name + '</h3><span class="sora-as__when">' + whenLabel + '</span></div>' +
        '<p class="sora-as__why">' + (pool.why || '') + ' <span class="sora-as__reason">' + reason + '</span></p>' +
        '<div class="sora-as__prod">' + prodInner(pool, item) + '</div>' +
        '<div class="sora-as__search">' +
          '<div class="sora-as__searchbar">' + svg('search') +
            '<input type="text" class="sora-as__searchinput" data-as-search data-pool="' + esc(pool.key) + '" placeholder="' + searchPlaceholder() + '" autocomplete="off">' +
          '</div>' +
          '<div class="sora-as__results" data-as-results hidden></div>' +
        '</div>' +
      '</div></div>';
  }
  function goalLabel() { var q = QUESTIONS[1]; var o = q.opts.filter(function (x) { return x.v === ans.goal; })[0]; return o ? o.t.toLowerCase() : ''; }
  function qLabel(key) { var q = QUESTIONS.filter(function (x) { return x.key === key; })[0]; if (!q) return ''; var o = q.opts.filter(function (x) { return x.v === ans[key]; })[0]; return o ? o.t : ''; }

  function chosenList() {
    var concern = ans.goal || 'hydration', level = LEVEL[ans.time || '6'] || 2, out = [];
    pools.forEach(function (pool) {
      if (!pool.products.length || (TIER[pool.tier] || 1) > level) return;
      var c = candidates(pool, concern);
      var item = manual[pool.key] || c.list[(swaps[pool.key] || 0) % c.list.length];
      out.push({ pool: pool, item: item, matched: c.matched });
    });
    return out;
  }
  function updateTotal() {
    var total = chosenList().reduce(function (s, r) { return s + r.item.price; }, 0);
    var tv = root.querySelector('.sora-as__ckv'); if (tv) tv.textContent = money(total);
  }

  function renderResult() {
    var list = chosenList();
    var total = 0, rows = '';
    list.forEach(function (r, i) { total += r.item.price; rows += slotHTML(r.pool, r.item, r.matched, i + 1); });
    var who = name ? (', ' + esc(name)) : '';
    var sum = [qLabel('skintype') && (qLabel('skintype') + ' skin'), qLabel('goal'), qLabel('finish'), (ans.time || '6') + ' steps']
      .filter(Boolean).join(' &nbsp;·&nbsp; ');
    fade('<div class="sora-as__result">' +
      '<div class="sora-as__resasthead"><p class="sora-as__kicker">Your personalized routine</p>' +
      '<h2 class="sora-as__h1">Here\'s your routine' + who + '</h2>' +
      '<p class="sora-as__lede">Layer these lightest to richest. Every step explains what it does — swap any product with “Try another”, or search for the exact one you want.</p>' +
      '<p class="sora-as__sum">' + sum + '</p></div>' +
      '<div class="sora-as__steps">' + rows + '</div>' +
      '<div class="sora-as__checkout"><div class="sora-as__cksum"><span class="sora-as__ckk">Full routine · ' + list.length + ' products</span><span class="sora-as__ckv">' + money(total) + '</span></div>' +
      '<button type="button" class="sora-as__cta" data-as-add>' + svg('cart') + ' Add routine to cart</button></div>' +
      '<button type="button" class="sora-as__restart" data-as-restart>Start over</button>' +
      '</div>');
  }

  /* ------- per-step product search (predictive) ------- */
  var timers = {};
  root.addEventListener('input', function (e) {
    var inp = e.target.closest('[data-as-search]');
    if (!inp) return;
    var key = inp.getAttribute('data-pool');
    var wrap = inp.closest('.sora-as__search');
    var out = wrap.querySelector('[data-as-results]');
    var q = inp.value.trim();
    clearTimeout(timers[key]);
    if (q.length < 2) { out.hidden = true; out.innerHTML = ''; return; }
    timers[key] = setTimeout(function () {
      out.hidden = false; out.innerHTML = '<span class="sora-as__hitnote">Searching…</span>';
      fetch(cartRoot + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide&resources[options][fields]=title,vendor,product_type,variants.title')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var ps = (d && d.resources && d.resources.results && d.resources.results.products) || [];
          if (!ps.length) { out.innerHTML = '<span class="sora-as__hitnote">No products found for “' + esc(q) + '”.</span>'; return; }
          out.innerHTML = ps.map(function (p) {
            var handle = p.handle || (p.url ? p.url.split('?')[0].split('/products/')[1] : '');
            var img = (p.featured_image && p.featured_image.url) || p.image || '';
            return '<button type="button" class="sora-as__hit" data-as-pick data-pool="' + esc(key) + '" data-handle="' + esc(handle) + '">' +
              (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '<span class="sora-as__hitph"></span>') +
              '<span class="sora-as__hitb">' + (p.vendor ? '<span class="sora-as__hitv">' + esc(p.vendor) + '</span>' : '') +
              '<span class="sora-as__hitt">' + esc(p.title) + '</span></span>' +
              (p.price ? '<span class="sora-as__hitp">$' + esc(p.price) + '</span>' : '') + '</button>';
          }).join('');
        })
        .catch(function () { out.innerHTML = '<span class="sora-as__hitnote">Search is unavailable right now.</span>'; });
    }, 280);
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.sora-as__search')) {
      root.querySelectorAll('[data-as-results]').forEach(function (o) { o.hidden = true; });
    }
  });
  function pickProduct(btn) {
    var key = btn.getAttribute('data-pool'), handle = btn.getAttribute('data-handle');
    if (!handle) return;
    btn.classList.add('is-busy');
    fetch(cartRoot + 'products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
      var v = null;
      (p.variants || []).forEach(function (x) { if (!v && x.available) v = x; });
      v = v || (p.variants && p.variants[0]);
      if (!v) return;
      var img = p.featured_image ? ((p.featured_image.indexOf('//') === 0 ? 'https:' : '') + p.featured_image) : '';
      manual[key] = { vid: String(v.id), price: v.price, title: p.title, brand: p.vendor || '', handle: p.handle, image: img, concerns: '' };
      var stepEl = root.querySelector('[data-step="' + key + '"]');
      var pool = pools.filter(function (x) { return x.key === key; })[0];
      if (stepEl && pool) {
        stepEl.querySelector('.sora-as__prod').innerHTML = prodInner(pool, manual[key]);
        var inp = stepEl.querySelector('[data-as-search]'); if (inp) inp.value = '';
        var out = stepEl.querySelector('[data-as-results]'); if (out) { out.hidden = true; out.innerHTML = ''; }
      }
      updateTotal();
    }).catch(function () { btn.classList.remove('is-busy'); });
  }

  /* ------- events ------- */
  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-as-next]')) { var inp = root.querySelector('[data-as-name]'); if (inp) name = inp.value.trim(); idx++; render(); return; }
    if (e.target.closest('[data-as-back]')) { if (idx > 0) { idx--; render(); } return; }
    var opt = e.target.closest('[data-as-opt]');
    if (opt) { var sc = SCREENS[idx]; ans[sc.q.key] = opt.getAttribute('data-as-opt'); idx++; render(); return; }
    var pick = e.target.closest('[data-as-pick]');
    if (pick) { pickProduct(pick); return; }
    var sw = e.target.closest('[data-as-swap]');
    if (sw) {
      var k = sw.getAttribute('data-as-swap');
      delete manual[k];
      swaps[k] = (swaps[k] || 0) + 1;
      var stepEl = sw.closest('.sora-as__step');
      var pool = pools.filter(function (p) { return p.key === k; })[0];
      var c = candidates(pool, ans.goal || 'hydration');
      var item = c.list[swaps[k] % c.list.length];
      if (stepEl && pool) stepEl.querySelector('.sora-as__prod').innerHTML = prodInner(pool, item);
      updateTotal();
      return;
    }
    if (e.target.closest('[data-as-restart]')) { idx = 0; ans = {}; swaps = {}; manual = {}; render(); return; }
    var qv = e.target.closest('[data-as-qv]'); if (qv) { openQV(qv); return; }
    if (e.target.closest('[data-as-add]')) { addAll(e.target.closest('[data-as-add]')); return; }
  });

  function addAll(btn) {
    var items = chosenList().map(function (r) { return { id: parseInt(r.item.vid, 10), quantity: 1 }; });
    if (!items.length) return;
    btn.disabled = true; btn.innerHTML = 'Adding…';
    fetch(cartRoot + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
      .then(function () { btn.innerHTML = svg('cart') + ' Added ✓'; document.dispatchEvent(new CustomEvent('cart:open')); setTimeout(function () { btn.disabled = false; btn.innerHTML = svg('cart') + ' Add routine to cart'; }, 1800); })
      .catch(function () { btn.disabled = false; btn.innerHTML = svg('cart') + ' Add routine to cart'; });
  }

  /* ------- quick view ------- */
  var qvEl = root.querySelector('[data-qv]'), q1 = function (s) { return qvEl.querySelector(s); };
  function openQV(el) {
    var handle = el.getAttribute('data-handle');
    q1('[data-qv-brand]').textContent = el.getAttribute('data-brand') || ''; q1('[data-qv-title]').textContent = el.getAttribute('data-title') || '';
    q1('[data-qv-price]').textContent = money(parseInt(el.getAttribute('data-price'), 10) || 0); q1('[data-qv-img]').src = el.getAttribute('data-image') || '';
    q1('[data-qv-desc]').textContent = 'Loading…'; q1('[data-qv-full]').href = cartRoot + 'products/' + handle; qvEl.hidden = false; document.body.classList.add('sora-cg-lock');
    fetch(cartRoot + 'products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
      q1('[data-qv-brand]').textContent = p.vendor || ''; q1('[data-qv-title]').textContent = p.title || ''; q1('[data-qv-price]').textContent = money(p.price);
      if (p.featured_image) q1('[data-qv-img]').src = (p.featured_image.indexOf('//') === 0 ? 'https:' : '') + p.featured_image;
      var tmp = document.createElement('div'); tmp.innerHTML = p.description || ''; var txt = (tmp.textContent || '').replace(/\s+/g, ' ').trim();
      q1('[data-qv-desc]').textContent = txt ? (txt.length > 260 ? txt.slice(0, 260) + '…' : txt) : 'A Soralady K-beauty pick.';
      q1('[data-qv-full]').href = p.url || q1('[data-qv-full]').href;
    }).catch(function () { q1('[data-qv-desc]').textContent = 'A Soralady K-beauty pick.'; });
  }
  function closeQV() { qvEl.hidden = true; document.body.classList.remove('sora-cg-lock'); }
  qvEl.addEventListener('click', function (e) { if (e.target.closest('[data-qv-close]')) closeQV(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !qvEl.hidden) closeQV(); });

  render();
})();
